/**
 * Base functions for building queries.
 */

export type CustomResponseModifierType<T, R> = (data: T) => R | undefined;

export interface QueryProps<T, P, R = T> {
  enabled?: boolean;
  onSuccess?: (res: T) => void;
  onError?: (error: Error) => void;
  onSettled?: () => void;
  initialData?: any;
  refetchOnWindowFocus?: boolean;
  refetchOnMount?: boolean;
  staleTime?: number;
  customResponseModifier?: CustomResponseModifierType<T, R>; // Function to modify response data in the query function.
  queryKeyOverride?: any[];
  params?: P;
  retry?: any;
}

export interface QueryFnProps<T, R = any> {
  serviceFn: (x?: any) => any;
  customResponseModifier?: CustomResponseModifierType<T, R>;
}

/**
 *  Base query function
 */
export const baseQueryFn = async <T, R = T>({ serviceFn, customResponseModifier = undefined }: QueryFnProps<T>) => {
  const res = await serviceFn();

  if (!customResponseModifier) {
    return res.data;
  }

  return customResponseModifier(res.data) as R;
};
